import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Canceled from './views/Canceled.vue'
import Storno from './views/Storno.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/rezervace-zrusena',
            name: 'canceled',
            component: Canceled
        },
        {
            path: '/rezervaci-nelze-zrusit',
            name: 'storno',
            component: Storno
        }
    ]
})
